var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c1c8d1;}.cls-2{fill:#e6e9ed;}.cls-3{fill:#7f7059;}.cls-4{fill:#96cc7f;}.cls-5{fill:#c0e0b2;}.cls-6{fill:#758190;}.cls-7{fill:#fddfb1;}.cls-8{fill:#7fcdee;}.cls-9{fill:#64a5f8;}.cls-10{fill:#83b7f9;}.cls-11{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:1px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 15",
    id: "Layer_15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 18,
    width: 32,
    x: 2,
    y: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2,40V52.91c.662.053,1.327.09,2,.09,9.209,0,17.445-5.053,22.948-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56,58h6a0,0,0,0,1,0,0v4a0,0,0,0,1,0,0H54a0,0,0,0,1,0,0V60A2,2,0,0,1,56,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56,58H52a2,2,0,0,0-2,2v2h4V60A2,2,0,0,1,56,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56,20h6a0,0,0,0,1,0,0V37a0,0,0,0,1,0,0H52a0,0,0,0,1,0,0V24A4,4,0,0,1,56,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52,24V34.822c4.532-.986,8-6.343,8-12.822a17.719,17.719,0,0,0-.124-2H56A4,4,0,0,0,52,24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 21,
    width: 10,
    x: 52,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 4,
    rx: 2,
    width: 16,
    x: 43,
    y: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57,24H54v4h3a2,2,0,0,0,0-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62,4H50a3.982,3.982,0,0,0,2,3.445V13a5,5,0,0,0,9.9.989c.034,0,.066.011.1.011l-.092-.092A4.939,4.939,0,0,0,62,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M62,13V4H50a4,4,0,0,0,4,4h2l3,4.646A3.991,3.991,0,0,0,62,14h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24,10h0a4,4,0,0,1,4,4V25a4,4,0,0,1-4,4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2 6 24 6 24 29 34 36 2 36 2 6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.52,33.564,24,29V6H2V36H29.355Q29.973,34.811,30.52,33.564Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    height: 4,
    width: 32,
    x: 2,
    y: 36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M29.355,36H2v4H26.948A37.312,37.312,0,0,0,29.355,36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    height: 4,
    width: 28,
    x: 2,
    y: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "2 6 30 6 30 2 2 2 2 62 34 62 34 36 2 36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    height: 4,
    width: 32,
    x: 2,
    y: 58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "24 6 24 29 34 36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 2,
    x2: 34,
    y1: 40,
    y2: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M24,10h0a4,4,0,0,1,4,4V25a4,4,0,0,1-4,4h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 33,
    x2: 36,
    y1: 15,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 33,
    x2: 36,
    y1: 23,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 34,
    x2: 38,
    y1: 19,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 2,
    x2: 34,
    y1: 58,
    y2: 58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 56,
    x2: 56,
    y1: 58,
    y2: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M52,7v6a5,5,0,0,0,5,5h0a5,5,0,0,0,5-5V4H50a4,4,0,0,0,4,4h2l3,4.646A3.991,3.991,0,0,0,62,14h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M52,24a4,4,0,0,1,4-4h6V62H54V60a2,2,0,0,1,2-2h6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 52,
    x2: 52,
    y1: 58,
    y2: 28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M54,62H50V60a2,2,0,0,1,2-2h4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 52,
    x2: 62,
    y1: 37,
    y2: 37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 4,
    rx: 2,
    width: 16,
    x: 43,
    y: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 54,
    x2: 54,
    y1: 24,
    y2: 28
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d1a4093dd66bb59d497f8c1e157d34b6.svg";
export { ForwardRef as ReactComponent };